export default __webpack_public_path__ + "static/media/logoWhite.df3a975b.png";